import * as Yup from "yup";

export const companyDataSchema = Yup.object().shape({
  base64: Yup.string(),
  changeRequestTip1: Yup.string(), // 변경구분 설명
  changeRequestTip2: Yup.string(), // 변경등급 설명

  // note not used
  // uid: Yup.number(),
  // guid: Yup.string(),
  // companyUID: Yup.number(),
  // changeGuideFile: Yup.string(), // 변경판단 기준 파일명
  // userManual: Yup.string(),
});
